import React from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Tooltip,
  Collapse,
} from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";
import { useTranslation } from "react-i18next";

interface OutputSectionProps {
  activeTab: number;
  outputPrompt: string;
  setOutputPrompt: (value: string) => void;
  imageDescription: string;
  setImageDescription: (value: string) => void;
  outputPromptNative: string;
  imageDescriptionNative: string;
  error: string;
  onInsert: () => void;
  onCancel: () => void;
}

const OutputSection: React.FC<OutputSectionProps> = ({
  activeTab,
  outputPrompt,
  setOutputPrompt,
  imageDescription,
  setImageDescription,
  outputPromptNative,
  imageDescriptionNative,
  error,
  onInsert,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Collapse in={!!outputPrompt || !!imageDescription || !!error} sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Divider />
        </Grid>

        {/* Output Section */}
        <Grid size={{ xs: 12 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="subtitle2">
              {activeTab === 0 ? t("juno.enhancement.output.label") : t("juno.enhancement.image.description")}
            </Typography>
            {((activeTab === 0 && outputPromptNative) || (activeTab === 1 && imageDescriptionNative)) && (
              <Tooltip title={activeTab === 0 ? outputPromptNative : imageDescriptionNative} placement="left">
                <IconButton size="small">
                  <TranslateIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
          <TextField
            fullWidth
            multiline
            rows={6}
            value={activeTab === 0 ? outputPrompt : imageDescription}
            onChange={(e) =>
              activeTab === 0 ? setOutputPrompt(e.target.value) : setImageDescription(e.target.value)
            }
            placeholder={
              activeTab === 0 ? t("juno.enhancement.output.placeholder") : t("juno.enhancement.image.placeholder")
            }
            variant="outlined"
          />
        </Grid>

        {/* Error Message */}
        {error && (
          <Grid size={{ xs: 12 }}>
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          </Grid>
        )}

        {/* Action Buttons */}
        <Grid size={{ xs: 12 }}>
          <Box display="flex" gap={2} justifyContent="flex-end">
            <Button onClick={onCancel} color="inherit">
              {t("common.cancel")}
            </Button>
            <Button
              onClick={onInsert}
              variant="contained"
              disabled={!(activeTab === 0 ? outputPrompt : imageDescription).trim()}
            >
              {t("juno.enhancement.insert")}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default OutputSection;